import React from 'react';
import Axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import * as Routes from '@/modules/routes';
import csrfToken from '../../shared/adminCsrf';
import RoutedSPADialog from '../../shared/RoutedSPADialog';
import StatesDialogContent, { StateOption } from '../StatesDialogContent';
import useProgramLessons, { usePatchLesson } from './useProgramLessons';

const fetchStates = (lessonId: number) => Axios
  .get(Routes.get_states_admin_lesson_path(lessonId, { format: 'json' }))
  .then(({ data }): StateOption[] => data ?? []);

const saveStates = (lessonId: number, stateIds: number[]) => Axios
  .post(
    Routes.set_states_admin_lesson_path(lessonId, { format: 'json' }),
    { lesson: { states: stateIds } },
    { headers: { 'X-CSRF-Token': csrfToken() } },
  )
  .then(({ data }): string => data?.selected ?? '');

const LessonStatesModal = () => {
  const navigate = useNavigate();
  const { lessonId, programId } = useParams<{ lessonId: string; programId: string }>();
  const pid = Number(programId);
  const id = Number(lessonId);
  const { allLessons } = useProgramLessons(pid);
  const patchLesson = usePatchLesson(pid);
  const lesson = allLessons.find(l => l.id === id);

  const handleSaved = (label: string) => {
    patchLesson(id, { states_selected: label });
    navigate('..');
  };

  return (
    <RoutedSPADialog>
      <StatesDialogContent
        description={lesson?.title_with_position}
        fetchStates={() => fetchStates(id)}
        saveStates={stateIds => saveStates(id, stateIds)}
        title="Edit State-Specific Access"
        onSaved={handleSaved}
      />
    </RoutedSPADialog>
  );
};

export default LessonStatesModal;
